(() => {
  const blockSelector = '.cc-main-product [data-app-block-id*="candy_rack"]';

  function promoteHeading() {
    let promoted = false;

    document.querySelectorAll(blockSelector).forEach((block) => {
      const headingText = (block.dataset.appTitleText || '').trim();
      if (!headingText) return;

      const heading = Array.from(block.querySelectorAll('h3')).find((element) => (
        element.dataset.promotedToH2 !== 'true' && element.textContent.trim() === headingText
      ));
      if (!heading) return;

      const newHeading = document.createElement('h2');
      Array.from(heading.attributes).forEach((attribute) => {
        newHeading.setAttribute(attribute.name, attribute.value);
      });
      newHeading.innerHTML = heading.innerHTML;
      newHeading.dataset.promotedToH2 = 'true';
      heading.replaceWith(newHeading);
      promoted = true;
    });

    return promoted;
  }

  function init() {
    promoteHeading();

    const productSection = document.querySelector('.cc-main-product');
    if (!productSection) return;

    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;

      requestAnimationFrame(() => {
        promoteHeading();
        queued = false;
      });
    });

    observer.observe(productSection, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
